/** Whether the site address's geocoded point is usable yet. */
export type SiteLocationReadiness = 'ready' | 'pending' | 'unavailable';

export const SITE_LOCATION_WAIT_MS = 10_000;

export const SITE_LOCATION_POLL_MS = 1_000;

export const resolveSiteLocationReadiness = (args: {
  hasCoordinates: boolean;
  /** Milliseconds since this site address was first seen (or last changed). */
  msSinceAddressSeen: number;
  waitMs?: number;
}): SiteLocationReadiness => {
  const {
    hasCoordinates,
    msSinceAddressSeen,
    waitMs = SITE_LOCATION_WAIT_MS,
  } = args;

  if (hasCoordinates) return 'ready';

  return msSinceAddressSeen < waitMs ? 'pending' : 'unavailable';
};
